import * as z from "zod";

export const acumaticaConnectionStatusSchema = z.enum([
  "disconnected",
  "pending",
  "connected",
  "reconnect",
]);

/** The counter stores the last used number, so a first number below 2 reads as unset. */
export const MIN_FIRST_RETURN_NUMBER = 2;
export const DEFAULT_FIRST_RETURN_NUMBER = 1001;

export const acumaticaReturnsSettingsSchema = z.object({
  createRma: z.boolean(),
  /** Sales-order type whose numbering sequence allows manual numbers. */
  rmaOrderType: z.string().trim().min(1).max(4),
  /** Warehouse for returned lines; null keeps the original line's warehouse. */
  warehouseId: z.string().min(1).nullable(),
  /** Process the Redo return once Acumatica completes the RMA. */
  processOnCompletion: z.boolean(),
});

export const acumaticaIntegrationSchema = z.object({
  status: acumaticaConnectionStatusSchema,
  instanceUrl: z.string().nullable(),
  clientId: z.string().nullable(),
  endpointVersion: z.string().nullable(),
  tokenInvalidatedAt: z.string().nullable(),
  returns: acumaticaReturnsSettingsSchema,
  /** Redirect URI the merchant registers on the Connected Application. */
  redirectUri: z.string(),
  /** Next Redo return number, or null when the team has no counter yet. */
  nextReturnNumber: z.number().int().nullable(),
});

export type AcumaticaIntegrationView = z.infer<
  typeof acumaticaIntegrationSchema
>;
